export interface ITagsState {
  tags: any;
  loading: boolean;
  error: Error | null;
}

const defaultState = {
  tags: [],
  loading: false,
  error: null
};

export const getDefaultTagsState = () => defaultState;
